import { DateTime } from 'luxon'

export const tradeCampaignAlterations = {
  data: () => ({
    campaignDateErrors: [],
    proposalDeadlineErrors: [],
    cashbackExpirationDateErrors: [],
  }),
  computed: {
    canAlterTradeOffers() {
      return this.$getIsAdmin() && this.includesThisStatus(['industry_proposal', 'scheduled', 'active'])
    },
  },
  methods: {
    validTradeOffersDate() {
      this.campaignDateErrors = []
      this.proposalDeadlineErrors = []
      this.cashbackExpirationDateErrors = []
      const thisCampaign = this.campaign || this.campanha

      const startDate = thisCampaign?.start_date
      const endDate = thisCampaign?.end_date
      if (!startDate || startDate === '' || !endDate || endDate === '') {
        this.campaignDateErrors.push('Este campo é obrigatório.')
        this.scrollWindowToError('.error--text')
        return false
      }

      const proposalDeadline = thisCampaign?.industry?.proposal_deadline
      if (!proposalDeadline || proposalDeadline === '') {
        this.proposalDeadlineErrors.push('Este campo é obrigatório.')
        this.scrollWindowToError('.error--text')
        return false
      }

      if (DateTime.fromISO(proposalDeadline) > DateTime.fromISO(thisCampaign?.end_date).endOf('day')) {
        this.proposalDeadlineErrors.push('O prazo de adesão deve ser anterior ou igual ao fim da campanha.')
        this.scrollWindowToError('.error--text')
        return false
      }

      if (thisCampaign?.next_buy_cashback_offer_sales?.length > 0 || thisCampaign?.cashback_absolute_offer_sales?.length > 0) {
        let cashbackExpirationDate = ''

        if (thisCampaign?.next_buy_cashback_offer_sales?.length > 0) {
          cashbackExpirationDate = thisCampaign?.next_buy_cashback_offer_sales?.[0]?.cashback_expiration_date
        } else if (thisCampaign?.cashback_absolute_offer_sales?.length > 0) {
          cashbackExpirationDate = thisCampaign?.cashback_absolute_offer_sales?.[0]?.expiration_cashback?.expires_at
        }

        if (!cashbackExpirationDate || cashbackExpirationDate === '') {
          this.cashbackExpirationDateErrors.push('Este campo é obrigatório.')
          this.scrollWindowToError('.error--text')
          return false
        }

        if (DateTime.fromISO(cashbackExpirationDate) < DateTime.fromISO(thisCampaign?.end_date)) {
          this.cashbackExpirationDateErrors.push('O prazo de vencimento de cashback deve ser posterior ou igual ao fim da campanha.')
          this.scrollWindowToError('.error--text')
          return false
        }
      }

      return true
    },
  },
}
